module.exports = __webpack_public_path__ + "static/media/carousel-placeholder-01.1d579588.jpg";